import topmenu from './topmenu.vue'
import wall from './wall.vue'
import scolltotop from './scolltotop.vue'
import foot from './foot.vue'

export default {
  topmenu,
  wall,
  scolltotop,
  foot
}



// WEBPACK FOOTER //
// ./src/components/index.js